import { translate } from "shared/languages";
import PATHS from "shared/constants/paths";
import PackageComparisonContent from "./PackageComparisonContent";

const PackageComparisonPage = () => (
  <PackageComparisonContent
    type="paket"
    title={translate("analyticsPage.package.report_compare")}
    backTo={PATHS.ANALYTICS}
  />
);

export default PackageComparisonPage;
